var Upgrade = Upgrade || (function () {
    var isOpened = false;
    var canClick = false;
    var leftValue = "-13%";
    var rightValueWizzard = "17%";
    var rightValueTimeline = "36%";
    var animationDuration = 2000;
    var showClockImageDuration = 500;
    var canRunAnimation = true;
    var openAnimation = function () {
        $(".cp-wizard-image").animate(
            {
                left: rightValueWizzard
            },
            {
                duration: animationDuration,
                queue: false,
                done: function () {
                    $(" .cp-h-m-image").animate({
                        opacity: 1
                    }, {
                        duration: showClockImageDuration,
                        queue: false
                    });
                }
            });

        $(".cp-timeline-image").animate(
            {
                left: leftValue
            },
            {
                duration: animationDuration,
                queue: false
            });
    }
    var closeAnimtion = function () {
        $(" .cp-h-m-image").animate({
            opacity: 0
        }, {
            duration: 0,
            queue: false
        });
        $(".cp-wizard-image").animate(
            {
                left: leftValue
            },
            {
                duration: animationDuration,
                queue: false
            });

        $(".cp-timeline-image").animate(
            {
                left: rightValueTimeline
            },
            {
                duration: animationDuration,
                queue: false
            });
    }
    var runAnimation = function () {
        openAnimation();
        canClick = false;
        isOpened = true;
        setTimeout(function () {
            canClick = true;
        }, (animationDuration + showClockImageDuration));
        $(".cp-images-container").click(function () {
            if (canClick) {
                if (canClick && !isOpened) {
                    openAnimation();
                    canClick = false;
                    isOpened = true;
                }
                if (canClick && isOpened) {
                    isOpened = false;
                    canClick = false;
                    closeAnimtion();
                }
                setTimeout(function () {
                    canClick = true;
                }, (animationDuration + showClockImageDuration));
            }
        });
    }

    var runAnimationOnPageScroll = function () {
        //animation starts when screen height + scroll offset >= animation container +50 px       
        if ($(window).height() + $(window).scrollTop() >= $(".cp-images-container").offset().top + 50) {
            runAnimation();
            canRunAnimation = false;
        } else {
            $(window).scroll(function () {
                if (canRunAnimation) {
                    if ($(window).height() + $(window).scrollTop() >= $(".cp-images-container").offset().top + 50) {
                        runAnimation();
                        canRunAnimation = false;
                    }
                }

            });
        }
    }

    var init = function () {
        runAnimationOnPageScroll();
    }

    $(document).ready(function () {
        init();
    });
    return {
        init: init
    }
})()
